import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";
import DirectoryFilter from "./DirectoryFilter";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../utilities/FormPageHeader";
import "../expense-claim/expenseClaim.css";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const SalaryBreakdown = () => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [isPermanent, setIsPermanent] = useState(false);
  const [basicAmount, setBasicAmount] = useState(null);
  const [basicCap, setBasicCap] = useState(null);
  const [hourAmount, setHourAmount] = useState(null);
  const [hourCap, setHourCap] = useState(null);

  const navigate = useNavigate();

  const [rowData, setRowData] = useState([
    {
      description: "Basic",
      amount: null,
      remark: null,
    },
    {
      description: "Housing",
      amount: null,
      remark: null,
    },
    {
      description: "Transport",
      amount: null,
      remark: null,
    },
    {
      description: "Car",
      amount: null,
      remark: null,
    },
    {
      description: "Flight Allowance",
      amount: null,
      remark: null,
    },
    {
      description: "Others",
      amount: null,
      remark: null,
    },
    {
      description: "GROSS SALARY",
      amount: null,
      remark: null,
    },
  ]);

  const onCellValueChanged = () => {
    const updatedData = [...rowData];
    const index = updatedData.findIndex(
      (item) => item.description === "GROSS SALARY"
    );
    const amount = rowData.map((item) =>
      item.amount === null ? 0 : parseInt(item.amount)
    );
    amount.pop();
    const sum = amount.reduce(function (a, b) {
      console.log(a, b);
      return a + b;
    });
    if (index !== -1) {
      updatedData[index] = { ...updatedData[index], amount: parseInt(sum) };
      setRowData(updatedData);
    }
  };

  const [columnDefs, setColumnDefs] = isPermanent
    ? useState([
        {
          field: "description",
          headerName: "Description",
          editable: false,
        },
        {
          field: "amount",
          headerName: "Amount",
        },
        {
          field: "remark",
          headerName: "Remarks",
        },
      ])
    : useState([
        {
          field: "description",
          headerName: "Description",
        },
        {
          field: "amount",
          headerName: "Amount",
          editable: (params) => params.data.description == "Basic",
        },
        {
          field: "remark",
          headerName: "Cap (1st Slab)",
          editable: (params) => params.data.description == "Basic",
        },
      ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      // let expenseClaimList = list.data._embedded.expenses;
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);
  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  const handleSave = () => {
    console.log("Save");
  };

  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "View",
        icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
        action: (props) => {
          navigate(
            `/salary/revision/action?val=view&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          navigate(
            `/salary/revision/action?val=edit&id=${event.node.data.code}`
          );
        },
      },
      {
        name: "Print",
        icon: '<span><i class="material-icons" style="font-size: 18px">print</i></span>',
        action: (props) => {
          // navigate(`/expense-claim/add?id=${event.node.data.id}`);
        },
      },
    ];
    return result;
  };

  return (
    <React.Fragment>
      <FormPageHeader
        componentName="Salary Breakdown"
        pageName="Salary Breakdown"
        currentPage="Salary Breakdown"
        handleSubmit={handleSave}
      />
      <Stack
        direction={"row"}
        className={"items-end"}
        sx={{ padding: 2, borderBottom: "1px solid" }}
      >
        <Stack className="mr-16">
          Emp Code
          <StyledTextField
            type="text"
            className="w-[80px]"
            variant="outlined"
          />
        </Stack>
        <Stack className="mr-16">
          Emp Name
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
          />
        </Stack>
        <Stack className="mr-16">
          Department
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
          />
        </Stack>
        <Stack className="mr-16">
          Sub Department
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
          />
        </Stack>
        <Stack className="mr-16">
          Designation
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
          />
        </Stack>
        <Stack className="mr-16">
          Pay Group
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
          />
        </Stack>
        <Button
          color="warning"
          variant="contained"
          startIcon={
            <FuseSvgIcon size={18}>heroicons-outline:search</FuseSvgIcon>
          }
          sx={{ mr: 1 }}
        />
      </Stack>
      <Grid container>
        {isPermanent ? (
          <Grid item xs={6} sx={{ padding: 2 }}>
            <Stack>
              <AgGridTable
                hideCheckbox={true}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                gridRef={gridRef}
                rowData={rowData}
                rowGroupPanelShow="never"
                getContextMenuItems={getContextMenuItems}
                pagination={false}
                onCellValueChanged={onCellValueChanged}
              />
            </Stack>
          </Grid>
        ) : (
          <>
            <Grid item xs={6} sx={{ padding: 2 }}>
              <Stack>
                <AgGridTable
                  hideCheckbox={true}
                  columnDefs={columnDefs}
                  onGridReady={onGridReady}
                  gridRef={gridRef}
                  rowData={rowData}
                  rowGroupPanelShow="never"
                  getContextMenuItems={getContextMenuItems}
                  pagination={false}
                  onCellValueChanged={onCellValueChanged}
                />
              </Stack>
            </Grid>
            <Grid item xs={4} sx={{ padding: 2 }}>
              <Stack>
                Rate Per Hour
                <Stack direction={"row"} sx={{ marginBottom: 1, marginTop: 1 }}>
                  <Stack sx={{ marginRight: 2 }}>
                    Amount
                    <TextField
                      className="mb-4 w-[130px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                      onChange={(e) => setHourAmount(e.target.value)}
                    />
                  </Stack>
                  <Stack sx={{ marginRight: 2 }}>
                    Cap
                    <TextField
                      className="mb-4 w-[100px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                      onChange={(e) => setHourCap(e.target.value)}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          </>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default SalaryBreakdown;
